import { Navigate } from "react-router-dom";
import { useCampaign } from "@/contexts/CampaignContext";

interface RequireStepCompletionProps {
	children: React.ReactNode;
	requiredStep: keyof ReturnType<typeof useCampaign>;
}

export function RequireStepCompletion({
	children,
	requiredStep,
}: RequireStepCompletionProps) {
	const campaignContext = useCampaign();

	if (!campaignContext[requiredStep]) {
		return <Navigate to="/create" replace />;
	}

	return <>{children}</>;
}
